import { render } from "./bidangTataLingkungan.vue?vue&type=template&id=4c6aff44"
import script from "./bidangTataLingkungan.vue?vue&type=script&lang=js"
export * from "./bidangTataLingkungan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__